import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Box, ClickAwayListener, Divider, Grid, Typography } from '@mui/material';
import ClinicApi from 'api/master/clinic.api';
import MemberManagementApi, { MemberManagementface } from 'api/setting/member.api';
import ButtonCustom from 'component/Button/ButtonCustom';
import HeaderLabel from 'component/CardCustom/HeaderLabel';
import HelperText from 'component/Input/HelperText';
import InputCheckbox from 'component/Input/InputCheckbox';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { KEY_STORAGE } from 'constants/common';
import { imgs } from 'constants/images';
import { colors } from 'constants/theme';
import SelectInput from 'new-components/inputs/select-input';
import TextAreaInput from 'new-components/inputs/text-area-input';
import TextInput from 'new-components/inputs/text-input';
import AlertModal from 'new-components/modal/alert-modal';
import PageModal from 'new-components/modal/page-modal';
import ColorManage from 'new-components/tags/color-manage';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { routeName } from 'routes/routes-name';
import { getBranch, setSecureItem } from 'utils/app.utils';
import { isCreate, isDelete, isUpdate } from 'utils/verification.utils';
import { ColorTag } from './style';

const permissions = {
      isCreate: isCreate(),
      isDelete: isDelete(),
      isUpdate: isUpdate(),
};

export default function FormMemberManagement() {
      const { t } = useTranslation();
      const location = useLocation();
      const { autoIncrement, defaultRankId }: any = location.state;
      const dispatch = useDispatch();
      const history = useHistory();
      const [rankId, setRankId] = useState<number | null>(null);
      const [rankCode, setRankCode] = useState('');
      const [rankName, setRankName] = useState('');
      const [rankNameEn, setRankNameEn] = useState('');
      const [rankNameDefault, setRankNameDefault] = useState('');
      const [rankColor, setRankColor] = useState('');
      const [totalPaid, setTotalPaid] = useState<number | string>('');
      const [serviceVisits, setServiceVisits] = useState<number | string>('');
      const [errorRank, setErrorRank] = useState<boolean>(false);
      const [popSelectColor, setPopSelectColor] = useState<boolean>(false);
      const [memberTypes, setMemberTypes] = useState<any[]>([]);
      const [memberType, setMemberType] = useState<any>({});
      const [duplicateName, setDuplicateName] = useState(false)
      const [duplicatePrice, setDuplicatePrice] = useState(false)
      const [detail, setDetail] = useState('')
      const [disabledSubmit, setDisabledSubmit] = useState(false)

      /** PAGINATION  */
      const [page, setPage] = useState(1);
      const [pageLimit, setPageLimit] = useState(10);
      const [rowCount, setRowCount] = useState(0);
      const [sortType, setSortType] = useState('ASC');
      const [sortBy, setSortBy] = useState<any>(autoIncrement);
      const [checkedIndex, setCheckedIndex] = useState<any>(defaultRankId);
      const [dfRankId, setDfRankId] = useState<any>(defaultRankId);
      const [ranks, setRanks] = useState<any[]>([]);
      const [openModal, setOpenModal] = useState(false);
      const [useStatus, setUseStatus] = useState('');
      const [isDisabled, setIsDisabled] = useState(true);
      const [loading, setLoading] = useState(false);
      const branchId = getBranch();
      const [isOpenModal, setIsOpenModal] = useState(false)
      const [index, setIndex] = useState<any>(null);

      const loadData = useCallback(async () => {
            try {
                  setLoading(true);
                  let condition: any = {};
                  if (page) condition = { ...condition, page: page };
                  if (pageLimit) condition = { ...condition, pageLimit: pageLimit };
                  if (sortBy) condition = { ...condition, sortBy: sortBy };
                  if (sortType) condition = { ...condition, sortType: sortType };
                  const res = await MemberManagementApi.findAll(condition);
                  if (res.status === 200) {
                        setSecureItem(KEY_STORAGE.MEMBER_RANKING_TYPE, JSON.stringify(res.data))
                        setRowCount(parseInt(res.headers['x-total'], 10));
                        setRanks(res.data);
                        setDfRankId(defaultRankId)
                        const defaultRank = res.data.find((e: any) => e.rankId === defaultRankId);
                        setRankNameDefault(defaultRank.rankNameEn);
                        setCheckedIndex(defaultRank.rankId);
                        setIsDisabled(true)
                        setLoading(false)
                  }
                  setLoading(false);
            } catch (error) {
                  console.error('Error loading data:', error);
                  setLoading(true);
            }
      }, [page, pageLimit, sortBy, sortType]);

      useEffect(() => {
            loadData();
      }, [loadData]);

      const onSubmit = async () => {
            if (!rankName || !rankColor || rankColor === '#' || !rankCode) {
                  setErrorRank(true);
                  return;
            }

            // if (sortBy === 'VISIT_COUNT' ? serviceVisits === '' : totalPaid === '') {
            //       setErrorRank(true);
            //       return;
            // }

            const newData: MemberManagementface = {
                  rankCode: rankCode,
                  rankName: rankName,
                  rankNameEn: rankName,
                  color: rankColor,
                  totalPaid: Number(totalPaid),
                  serviceVisits: Number(serviceVisits),
                  detail: detail
            };
            if (rankId) {
                  await MemberManagementApi.update(rankId, newData)
                        .then((res: any) => {
                              setIsOpenModal(false)
                              if (res.status === 200) {
                                    notiSuccess(t(`MEMBER.MESSAGE.SUCCESS.UPDATE`));
                                    loadData();
                                    clearForm()
                              } else notiError(t('MEMBER.MESSAGE.ERROR'));
                        })
                        .catch((error) => {
                              const errorMessage = error?.response?.data?.message;
                              if (errorMessage === 'IS_DUPLICATE_RANK_NAME') {
                                    setDuplicateName(true)
                              } else if (errorMessage === 'IS_DUPLICATE_TOTAL_PAID') {
                                    setDuplicatePrice(true)
                              } else {
                                    notiError(t(`MEMBER.MESSAGE.ALERT.${errorMessage}`));
                              }
                              clearForm()
                        });
            } else {
                  await MemberManagementApi.create(newData)
                        .then((res: any) => {
                              setIsOpenModal(false)
                              if (res.status === 201) {
                                    notiSuccess(t(`MEMBER.MESSAGE.SUCCESS.CREATE`));
                                    loadData();
                                    resetForm()
                              } else {
                                    notiError(t('MEMBER.MESSAGE.ERROR'));
                              }
                        })
                        .catch((error) => {
                              const errorMessage = error?.response?.data?.message;
                              if (errorMessage === 'IS_DUPLICATE_RANK_NAME') {
                                    setDuplicateName(true)
                              } else if (errorMessage === 'IS_DUPLICATE_TOTAL_PAID') {
                                    setDuplicatePrice(true)
                              } else {
                                    notiError(t(`MEMBER.MESSAGE.ALERT.${errorMessage}`));
                              }
                        });
            }
      };

      const hasDuplicate = (name: string) => {
            const arr: any[] = [];
            for (const rank of ranks) {
                  if (Number(rank[name]) === 0) return true;
                  arr.push(Number(rank[name]));
            }
            return arr.some((item, index) => arr.indexOf(item) !== index);
      };

      const updateAutoIncremet = async () => {
            await ClinicApi.updateAutoIncremet({ autoIncrement: sortBy, defaultRankId: checkedIndex }, branchId)
                  .then((res: any) => {
                        if (res.status === 200) {
                              notiSuccess(t('MEMBER.MESSAGE.SUCCESS.UPDATE_STATUS'));
                              setDisabledSubmit(false)
                              history.push(routeName.memberManagement)

                        } else {
                              setDisabledSubmit(false)
                              notiError(t('MEMBER.MESSAGE.ERROR'));
                        }
                  })
      }


      const submit = async () => {
            try {
                  setDisabledSubmit(true)
                  setOpenModal(false);
                  if (!isDisabled) {
                        setDisabledSubmit(false)
                        notiError(t('MEMBER.MESSAGE.ALERT.HAS_DEFAULT'));
                        return
                  }
                  if (sortBy === 'NO_SETTING') updateAutoIncremet()
                  else {
                        const fieldToCheck = sortBy === 'TOTAL_SPENDING' ? 'totalPaid' : 'serviceVisits';
                        if (hasDuplicate(fieldToCheck)) {
                              setDisabledSubmit(false)
                              notiError(t('MEMBER.MESSAGE.ALERT.HAS_DOUBLY'));
                        } else updateAutoIncremet()
                  }
            } catch (e) {
                  setDisabledSubmit(false)
                  setOpenModal(false);
                  notiError(t('MEMBER.MESSAGE.ERROR'));
            }
      };

      const onEdit = (data: any, index?: number) => {
            const { rankId, rankCode, rankName, rankNameEn, color, totalPaid, serviceVisits, detail } = data;
            setIndex(index)
            setRankId(rankId);
            setRankCode(rankCode);
            setRankName(rankName);
            setRankNameEn(rankNameEn);
            setRankColor(color);
            setDetail(detail)
            setTotalPaid(Number(totalPaid) === 0 ? '' : totalPaid);
            setServiceVisits(Number(serviceVisits) === 0 ? '' : serviceVisits);
            setIsOpenModal(true)
      };

      const onDelete = () => {
            setOpenModal(false);
            if (rankId) {
                  MemberManagementApi.remove(rankId)
                        .then((resp) => {
                              if (resp.status === 200) {
                                    resetForm()
                                    notiSuccess(t('MEMBER.MESSAGE.SUCCESS.DELETE'));
                                    loadData();
                              } else notiError(t('MEMBER.MESSAGE.ERROR'));
                        })
                        .catch((e) => notiError(t('MEMBER.MESSAGE.ERROR')));
            }
      };

      const onChange = (evant?: string) => {
            if (evant) {
                  setLoading(false);
                  setSortBy(evant);
                  setUseStatus('CHANGE');
                  setIsDisabled(true)
                  loadData()
            } else notiError(t('MEMBER.MESSAGE.ERROR'));
      };



      const headCells = [
            { id: 'no', disablePadding: false, label: t('TABLE.NO') },
            { id: 'rankCode', disablePadding: false, label: t('MEMBER.TABLE.CELL.MEMBER_ID') },
            { id: 'rankName', disablePadding: false, label: t('MEMBER.TABLE.CELL.MEMBER_NAME') },
            { id: 'color', disablePadding: false, label: t('MEMBER.TABLE.CELL.COLOR') },
            { id: 'defaults', disablePadding: false, label: t('MEMBER.TABLE.CELL.IS_DEFAULT') },
            { id: 'price', disablePadding: false, label: t('MEMBER.TABLE.CELL.TOTAL_AMOUNT') },
            { id: 'detail', disablePadding: false, label: t('MEMBER.TABLE.CELL.DETAIL') },
            { id: 'updatedBy', disablePadding: false, label: t('MEMBER.TABLE.CELL.UPDATED_BY') },
            { id: 'action', disablePadding: false, label: 'Action' },
      ];

      const renderData = (objData: any, no: number) => {
            no = page * pageLimit - pageLimit + no + 1;
            const { rankId, rankCode, rankNameEn, color, totalPaid, serviceVisits, updatedBy, updatedAt, detail } = objData;
            const mappings: { [key: string]: string } = {
                  'TOTAL_SPENDING': `${totalPaid} ${t('MEMBER.UNIT.BATH')}`,
                  'VISIT_COUNT': `${serviceVisits} ${t('MEMBER.UNIT.TIME')}`,
            };
            const objRenderData = {
                  key: rankId,
                  id: rankId,
                  obj: objData,
                  columns: [
                        { option: 'TEXT', align: 'center', label: no },
                        { option: 'TEXT', align: 'left', label: rankCode },
                        { option: 'TEXT', align: 'left', label: rankNameEn },
                        {
                              option: 'COMPONENT',
                              align: 'left',
                              component: (
                                    <Box sx={{ background: `${color}`, height: '40px', width: '200px', border: '1px solid #C5C5C5' }} />
                              ),
                        },
                        {
                              option: 'COMPONENT',
                              align: 'center',
                              component: (
                                    <Box>
                                          <InputCheckbox
                                                disabled={checkedIndex === rankId ? false : isDisabled}
                                                checked={checkedIndex === rankId}
                                                onChange={(e) => {
                                                      const isChecked = e.target.checked;
                                                      setCheckedIndex(isChecked ? rankId : null);
                                                      setIsDisabled(isChecked);
                                                      setDfRankId(!isChecked ? defaultRankId : null)
                                                }}
                                                value={checkedIndex === no ? '1' : '0'}
                                          />
                                    </Box>
                              ),
                        },
                        { option: 'TEXT', align: 'right', label: mappings[sortBy] || '-' },
                        {
                              option: 'COMPONENT', class: '', component: (
                                    <Typography sx={{ width: '300px', maxWidth: '300px' }}>{detail}</Typography>
                              )
                        },
                        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
                        {
                              option: 'ACTION',
                              align: 'center',
                              label: 'action',
                              values: [
                                    { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
                                    { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: checkedIndex !== rankId && dfRankId !== rankId ? permissions.isDelete.disabled : true },
                              ],
                        },
                  ],
            };
            return (
                  <TableRowCommon
                        {...objRenderData}
                        onedit={() => onEdit(objRenderData.obj, no)}
                        ondelete={() => handleModal('DELETED', objRenderData.obj)}
                  />
            );
      };

      const onRequestSort = (sortByVal: any, sortTypeVal: string) => {
            setSortType(sortTypeVal);
            setSortBy(sortByVal);
            loadData();
      };

      const handleModal = (valueStatus: string, obj?: any) => {
            if (valueStatus === 'DELETED') {
                  setRankId(obj.rankId);
                  setRankName(obj.rankName);
                  setRankNameEn(obj.rankNameEn);
                  setUseStatus(valueStatus);
                  setOpenModal(true);
            }
      };

      const resetForm = () => {
            setRankId(null);
            setRankCode('');
            setRankName('');
            setRankNameEn('');
            setRankColor('');
            setTotalPaid('');
            setServiceVisits('');
            setUseStatus('');
            setDetail('')
      };

      const clearForm = () => {
            resetForm();
            setErrorRank(false);
            setDuplicateName(false)
            setDuplicatePrice(false)
            setIsOpenModal(false)
      };

      const handleChangeColor = ({ hex }: { hex: string }) => {
            setErrorRank(false);
            setRankColor(hex);
      };

      const handleSubmit = () => {
            if (sortBy !== autoIncrement) setOpenModal(true)
            else submit()
      };

      return (
            <Box sx={{ backgroundColor: 'white', overflow: 'hidden' }}>
                  <AlertModal
                        isOpen={openModal}
                        handleClose={() => setOpenModal(false)}
                        type={useStatus === 'DELETED' ? 'error' : 'warning'}
                        title={
                              useStatus === 'DELETED'
                                    ? `${t('MEMBER.ALERT.CONFIRM_STATUS_')}${t(`BUTTON.DELETE_`)}`
                                    : `${t('MEMBER.ALERT.CONFIRM_SETTING_CHANGE')}`
                        }
                        message={
                              useStatus === 'DELETED'
                                    ? `${t('MEMBER.ALERT.CONFIRM_DELETE_', { rankName: rankNameEn })}`
                                    : `${t('MEMBER.ALERT.CONFIRM_STATUS', { rankName: t(`MEMBER.AUTO_PROMOTION.${sortBy}`) })}`
                        }
                        onSubmit={{ onClick: useStatus === 'DELETED' ? onDelete : submit, title: t('BUTTON.SUBMIT') }}
                        onCancel={{ onClick: () => setOpenModal(false), title: t('BUTTON.CANCEL') }}
                  >
                        <Box display={'flex'} justifyContent={'center'}> <Typography textAlign="center" fontSize="14px" fontWeight={400}>{useStatus === 'DELETED'
                              ? `${t('MEMBER.ALERT.CHANGE_TO_DEFAULT_LEVEL_NOTICE', { rankName: rankNameDefault })}`
                              : `${t('MEMBER.ALERT.ACCUMULATION_RESET_WARNING')}`}</Typography></Box>
                  </AlertModal>
                  <PageModal
                        isOpen={isOpenModal}
                        title={rankId ? t('MEMBER.TITLE_UPDATE') : t('MEMBER.TITLE_CREATE')}
                        size='XS'
                        handleClose={() => clearForm()}
                        onCancel={{ onClick: () => clearForm(), title: t('BUTTON.CANCEL') }}
                        onSubmit={{ onClick: () => onSubmit(), title: t('BUTTON.SAVE') }}
                  >
                        <Box display="flex" flexDirection="column">
                              <Typography fontWeight={400} fontSize="16px">{t('MEMBER.INPUT.LEVEL')} {rankId ? index : rowCount + 1}</Typography>
                              <Box marginTop="16px">
                                    <TextInput
                                          label={t('MEMBER.INPUT.CODE')}
                                          value={rankCode}
                                          onChange={(event) => {
                                                if (!event.target.value.match(/[`~%^&*!@#$()_|+\-=?;:'",.<>{}[\]\\/]/g)) {
                                                      setErrorRank(false);
                                                      setRankCode(event.target.value);
                                                }
                                          }}
                                          required
                                          fullWidth
                                          helperText={errorRank && (!rankCode || rankCode === '') ? t('MEMBER.MESSAGE.ALERT.RANKCODE_PLEASE') : ''}
                                    />
                              </Box>
                              <Box>
                                    <Typography sx={{ textAlign: 'right', fontSize: '10px' }}>{rankName.length}/15</Typography>
                                    <TextInput
                                          label={t('MEMBER.INPUT.MEMBER_NAME')}
                                          value={rankName}
                                          onChange={(event) => {
                                                setErrorRank(false);
                                                setDuplicateName(false)
                                                const newValue = event.target.value;
                                                if (newValue?.length <= 15) setRankName(newValue);
                                          }}
                                          required
                                          fullWidth
                                          helperText={errorRank && (!rankName || rankName === '') ? t('MEMBER.MESSAGE.ALERT.RANKNAME_PLEASE') : duplicateName ? t('MEMBER.MESSAGE.ALERT.IS_DUPLICATE_RANK_NAME') : ''}
                                    />
                              </Box>
                              <Box marginTop="16px">
                                    {sortBy !== 'NO_SETTING' && (
                                          <TextInput
                                                label={sortBy === 'TOTAL_SPENDING' ? t('MEMBER.INPUT.SPENDING_THRESHOLD') : t('MEMBER.INPUT.TOTAL_VISITS_SINCE')}
                                                onChange={(event: any) => {
                                                      if (!isNaN(event.target.value)) {
                                                            setDuplicatePrice(false)
                                                            setErrorRank(false);
                                                            const value = Number(event.target.value);
                                                            if (value > 0) {
                                                                  setErrorRank(false);
                                                                  sortBy === 'TOTAL_SPENDING' ? setTotalPaid(value) : setServiceVisits(value);
                                                            }
                                                            else {
                                                                  sortBy === 'TOTAL_SPENDING' ? setTotalPaid('') : setServiceVisits('');
                                                            }
                                                      }
                                                }}
                                                required
                                                fullWidth
                                                helperText={errorRank && (sortBy === 'TOTAL_SPENDING' ?
                                                      !totalPaid || totalPaid === '' || totalPaid === 0 : !serviceVisits || serviceVisits === '' || serviceVisits === 0) ?
                                                      sortBy === 'TOTAL_SPENDING' ? t('MEMBER.MESSAGE.ALERT.RANK_TOTAL_PAID_PLEASE') : t('MEMBER.MESSAGE.ALERT.RANK_VISIT_PLEASE') : duplicatePrice ? t('MEMBER.MESSAGE.ALERT.IS_DUPLICATE_TOTAL_PAID') : ''}
                                                value={sortBy === 'TOTAL_SPENDING' ? `${totalPaid ?? ''}` : `${serviceVisits ?? ''}`}
                                          />
                                    )}
                              </Box>
                              <Box marginTop="16px">
                                    <TextAreaInput
                                          onChange={(event) => setDetail(event.target.value)}
                                          label={t('MEMBER.INPUT.DETAIL')}
                                          rows={2}
                                          fullWidth
                                          maxLength={500}
                                          inputProps={{
                                                value: detail,
                                                style: {
                                                      display: 'flex',
                                                      justifyContent: 'flex-end',
                                                      alignItems: 'flex-start',
                                                      fontSize: "12px"
                                                },
                                                startAdornment: (
                                                      <Box sx={{ position: "absolute", bottom: "2px" }}>
                                                            <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${detail?.length || 0}/500`}</Box>
                                                      </Box>
                                                ),
                                          }}
                                    />
                              </Box>
                              <Box marginTop="16px">
                                    <Box>
                                          {t('MEMBER.INPUT.MEMBER_COLOR')}
                                          <span style={{ color: colors.statusInactive, marginLeft: '3px' }}>*</span>
                                    </Box>
                                    <ClickAwayListener onClickAway={() => setPopSelectColor(false)}>
                                          <Box sx={{ position: 'relative' }}>
                                                <ColorTag
                                                      color={rankColor || 'transparent'}
                                                      error={errorRank && (!rankColor || rankColor === '' || rankColor === '#')}
                                                      onClick={() => setPopSelectColor(!popSelectColor)}
                                                />
                                                {errorRank && (!rankColor || rankColor === '' || rankColor === '#') && (
                                                      <Box>
                                                            <HelperText label={t('MEMBER.MESSAGE.ALERT.RANKCOLOR_PLEASE')} />
                                                      </Box>
                                                )}
                                                {popSelectColor && (
                                                      <ColorManage
                                                            color={rankColor}
                                                            setColor={setRankColor}
                                                            handleChangeColor={handleChangeColor}
                                                            onLoadMember={loadData}
                                                            memberTypes={memberTypes}
                                                            memberType={memberType}
                                                            handleChangeMember={(val) => setMemberType(val)}
                                                      />
                                                )}
                                          </Box>
                                    </ClickAwayListener>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={imgs.defaultAvatar} alt='defaultAvatar' style={{ marginTop: '10px', border: `5px solid ${rankColor === '#' ? colors.white : rankColor || 'transparent'}`, borderRadius: '80px', backgroundColor: colors.white }} width='85px' height='85px' />
                              </Box>
                              <Box sx={{ height: '32px', padding: '4px 8px 4px 8px', gap: '10px', borderRadius: '4px', marginTop: '10px', background: rankColor || 'transparent' }}>
                                    <Typography sx={{ fontSize: '16px', fontWeight: 700, color: colors.white, textAlign: 'center' }}>{rankName || ''}</Typography>
                              </Box>
                        </Box>
                  </PageModal>
                  <HeaderLabel
                        text={t('MEMBER.TITLE_UPDATE')}
                        navigator={{ previousTo: routeName.memberManagement, previousTitle: t('MEMBER.TITLE'), currentTitle: t('MEMBER.TITLE_UPDATE') }}
                        goBack={routeName.memberManagement}
                        onSubmit={() => sortBy === autoIncrement ? submit() : handleSubmit()}
                        disabled={disabledSubmit}
                  />
                  <Box padding="24px">
                        <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
                              <Grid container spacing="16px">
                                    <Grid item xs={2}>
                                          <Typography fontSize='18px' fontWeight={500}>{t('MEMBER.LABEL.CONDITIONS_SETTING')}</Typography>
                                    </Grid>
                                    <Grid item xs={10}></Grid>
                                    <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                          <Typography>{t('MEMBER.LABEL.AUTO_PROMOTION')}</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                          <SelectInput
                                                label={t('MEMBER.LABEL.AUTO_PROMOTION')}
                                                options={[
                                                      { name: t('MEMBER.AUTO_PROMOTION.NO_SETTING'), value: 'NO_SETTING', disabled: sortBy === 'NO_SETTING' },
                                                      { name: t('MEMBER.AUTO_PROMOTION.TOTAL_SPENDING'), value: 'TOTAL_SPENDING', disabled: sortBy === 'TOTAL_SPENDING' },
                                                      { name: t('MEMBER.AUTO_PROMOTION.VISIT_COUNT'), value: 'VISIT_COUNT', disabled: sortBy === 'VISIT_COUNT' },
                                                ]}
                                                onChange={(evant: any) => onChange(evant.target.value)}
                                                value={sortBy}
                                                defaultValue={sortBy}
                                          />
                                    </Grid>
                                    <Grid item xs={6}></Grid>
                              </Grid>
                              <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, width: '100%', marginY: '24px', marginLeft: '-2px !important', marginRight: '-8px !important' }} />
                              <Grid container sx={{ width: '100%', justifyContent: 'space-between' }}>
                                    <Grid item>
                                          <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>{t('MEMBER.LABEL.SET_MEMBER_LEVEL')}</Typography>
                                    </Grid>
                                    <Grid item>
                                          <ButtonCustom
                                                variant="outlined"
                                                startIcon={<AddCircleIcon />}
                                                onClick={() => setIsOpenModal(true)}
                                                textButton={t('MEMBER.BUTTON.ADD')}
                                          />
                                    </Grid>
                              </Grid>
                              <Box marginTop='16px'>
                                    <TableCustom
                                          page={page}
                                          pageLimit={pageLimit}
                                          sortType={sortType}
                                          sortBy={sortBy}
                                          onSort={onRequestSort}
                                          setPageLimit={(limit) => setPageLimit(limit)}
                                          setPage={(val) => setPage(val)}
                                          rowCount={rowCount}
                                          headCells={headCells}
                                          rowsData={ranks.map((val: any, i) => {
                                                return renderData(val, i);
                                          })}
                                    />
                              </Box>
                        </Box>
                  </Box>
            </Box>
      );
}


